import * as React from "react";

function SvgDollarSignDisabled(props) {
  return <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><g clipPath="url(#dollar-sign-disabled_svg__clip0_1606_26128)" stroke="#4A5568" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"><path d="M8 .667v14.666M11.333 3.333h-5a2.333 2.333 0 100 4.667h3.334a2.333 2.333 0 010 4.667H4" /></g><defs><clipPath id="dollar-sign-disabled_svg__clip0_1606_26128"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}

export default SvgDollarSignDisabled;